import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prove" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_feedback = _resolveComponent("feedback")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
      type: "card",
      class: "demo-tabs",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "游学证明",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: 
            _ctx.baseImage == ''
              ? 'https://nanchangfile.oss-cn-beijing.aliyuncs.com/prove.png'
              : _ctx.baseImage
          ,
                alt: ""
              }, null, 8, _hoisted_2)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_upload, {
                ref: "upload",
                class: "upload-demo",
                "on-change": _ctx.changeFile,
                "on-exceed": _ctx.handleExceed,
                "on-success": _ctx.onSuccess,
                action: _ctx.UpdateApi,
                limit: 1,
                "auto-upload": false
              }, {
                trigger: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("选择文件")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "ml-3",
                    type: "success",
                    onClick: _ctx.submitUpload
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode(" 上传到服务器 ")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["on-change", "on-exceed", "on-success", "action"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "调查问卷",
          name: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_feedback)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])
  ], 64))
}